export default __webpack_public_path__ + "static/media/linkedin-logo.6b60fb91.svg";